import { useRenterDashboardContext } from "./useRenterDashboardContext";
import RenterPersonalField from "./RenterPersonalField";
import { getPersonalInfoList } from "../../../../common/helpers/renter-edit-constants";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

export function RenterInfo() {
  const { renter } = useRenterDashboardContext();
  const personalInfoList = getPersonalInfoList(renter);
  return (
    <div className="tabs-border-line">
      {/* Informações Pessoais */}
      <section className="tabs-item-style">
        <h2 className="font-semibold text-2xl mb-4">Informações Pessoais</h2>
        <section className="grid grid-cols-3 gap-2 mb-4">
          <div className="grid grid-cols-1 text-sm lg:text-lg col-span-3 gap-2 sm:grid-cols-2 xl:grid-cols-3">
            {personalInfoList.map((info, index) => {
              return (
                <RenterPersonalField
                  key={index}
                  label={info.label}
                  value={info.value}
                />
              );
            })}
          </div>
        </section>
        <div className="flex items-center mb-6">
          {
            <span className="text-md font-semibold text-gray-600">
              Validação Jurídica:
            </span>
          }
          <span className="ml-2">
            {renter.jurValidation.validated === false ? (
              <></>
            ) : renter.jurValidation.status ? (
              <FaCheckCircle size={24} className="text-greenPrimary" />
            ) : (
              <FaTimesCircle size={24} className="text-redPrimary" />
            )}
          </span>
        </div>
        {/* <section>
          <div className="grid grid-cols-2 gap-2 mb-2">
            <div className="relative h-20 w-full sm:w-full color flex flex-col space-y-4">
              <p className="text-md font-semibold text-gray-600">Foi indicado por alguém?</p>
              <div className="flex items-center space-x-4">
                <label htmlFor="cpfDoIndicadorOptions.indicated" className="flex items-center space-x-2 text-sm font-medium text-gray-600 cursor-pointer">
                  <input
                    id="cpfDoIndicadorOptions.indicated"
                    name="cpfDoIndicadorOptions.indicated"
                    type="checkbox"
                    checked={renter.cpfDoIndicadorOptions?.indicated}
                    className="hidden"
                  />
                  {renter.cpfDoIndicadorOptions?.indicated ? (
                    <ImCheckboxChecked className="text-greenPrimary" />
                  ) : (
                    <ImCheckboxUnchecked className="text-redPrimary" />
                  )}
                  <span>Sim</span>
                </label>
                <label htmlFor="cpfDoIndicadorOptions.notIndicated" className="flex items-center space-x-2 text-sm font-medium text-gray-600 cursor-pointer">
                  <input
                    id="cpfDoIndicadorOptions.notIndicated"
                    name="cpfDoIndicadorOptions.notIndicated"
                    type="checkbox"
                    checked={renter.cpfDoIndicadorOptions?.notIndicated}
                    className="hidden"
                  />
                  {renter.cpfDoIndicadorOptions?.notIndicated ? (
                    <ImCheckboxChecked className="text-greenPrimary" />
                  ) : (
                    <ImCheckboxUnchecked className="text-redPrimary" />
                  )}
                  <span>Não</span>
                </label>
              </div>
            </div>
            <div></div>
            <div>
              {renter.cpfDoIndicadorOptions?.indicated ? (
                <>
                  <label className="font-semibold text-sm">CPF da pessoa que o(a) indicou:</label>
                  <p className="border border-gray h-[43px] text-gray2 mb-3 p-2 overflow-hidden rounded w-full bg-[#ffffff]">{renter.cpfDoIndicador}</p>
                </>
              ) : null}
            </div>
          </div>
        </section> */}
      </section>
    </div>
  );
}

export default RenterInfo;
